import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "edit-ticket-footer" }
const _hoisted_2 = { class: "edit-ticket-footer__dates" }
const _hoisted_3 = {
  key: 0,
  class: "edit-ticket-footer__buttons"
}

import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { computed, inject } from 'vue'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import { UpdateTicket } from '@/services/tickets.service'

interface EMITS {
  (e: 'cancelEditTicket'): void
  (e: 'updateTicket'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EditTicketFooter',
  props: {
    createdDate: {},
    lastModifiedDate: {}
  },
  emits: ["cancelEditTicket", "updateTicket"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const { t } = useI18n()
const store = useStore()
const formData = inject<UpdateTicket>('formDataEditErrand')

const createdDate = computed<string>(() => props.createdDate)
const disableSaveButton = computed(() => {
  return (
    !formData?.title?.length ||
    !formData?.typeId ||
    !formData?.categoryId ||
    !formData?.status ||
    !formData?.priority
  )
})
const lastModifiedDate = computed<string>(() => props.lastModifiedDate)

const selectedTicketCreatedDate = computed<string>(() =>
  createdDate.value.length
    ? t('general__text__created-was') + ' ' + formatDate(createdDate.value)
    : ''
)
const selectedTicketLastModifiedDate = computed<string>(() =>
  lastModifiedDate.value.length
    ? t('general__text__updated-was') + ' ' + formatDate(lastModifiedDate.value)
    : ''
)

function formatDate(value: string) {
  return new Date(value).toLocaleDateString('sv-SE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(selectedTicketCreatedDate.value), 1),
      _createElementVNode("p", null, _toDisplayString(selectedTicketLastModifiedDate.value), 1)
    ]),
    (_unref(store).getters.hasErrandEditorAccess)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(ButtonOutline, {
            buttonText: _unref(t)('general__text__cancel'),
            onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (emits('cancelEditTicket')))
          }, null, 8, ["buttonText"]),
          _createVNode(ButtonPrimary, {
            buttonText: `${_unref(t)('general__text__update')} ${_unref(t)(
          'general__data__ticket-the'
        ).toLowerCase()}`,
            disabled: disableSaveButton.value,
            onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (emits('updateTicket')))
          }, null, 8, ["buttonText", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})